// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n6-3";
export var downloadButton = "_n6-4";
export var fileContainer = "_n6-9 _n6-7";
export var fileContainerBase = "_n6-7";
export var fileContainerFixedHeight = "_n6-8 _n6-7";
export var fileInfo = "_n6-5";
export var fileInfoWidthRestricted = "_n6-6";
export var fileType = "_n6-1";
export var fileTypeName = "_n6-2";
export var image = "_n6-0";
export var link = "_n6-b";
export var overflowEllipsis = "_n6-a";